<template>
    <div class="default">
        <el-container class="default">
            <el-header style="height:70px;"><v-head @onHospitalFn="onHospitalFn"></v-head></el-header>
			<iframe class="hospital-view" v-show="isHospital" :src="hospitalUrl" frameborder="0"></iframe>
            <el-container style="width:100%;height:calc(100% - 70px);" v-show="!isHospital">
                <el-aside width="200px"><v-leftMenu></v-leftMenu></el-aside>
                <el-container style="background:#D9D9D9;">
                    <v-tabs></v-tabs>
                    <el-main class="home-main">
                        <div class="content">
                            <router-view  v-slot="{ Component }">
                                <keep-alive>
                                    <component :is="Component" :key="$route.meta.id" v-if="$route.meta.keepAlive"></component>
                                </keep-alive>
                                <component :key="$route.meta.id" :is="Component" v-if="!$route.meta.keepAlive" />
                            </router-view>
                            <!-- IM 系统 iframe 由布局常驻托管：路由切走只切显隐、不卸载，避免 iframe 被 keep-alive
                                 移出文档后再插入时重新加载（会丢失当前咨询的用户和聊天记录）。见 api/imFrame.js -->
                            <iframe
                                v-if="imFrameMounted && imFrameUrl"
                                v-show="showImFrame"
                                class="im-persistent-view"
                                :src="imFrameUrl"
                                frameborder="0"
                            ></iframe>
                            <!-- <transition>
                                <keep-alive>
                                    <router-view/>
                                </keep-alive>
                            </transition> -->
                            <!-- <el-backtop target=".content"></el-backtop> -->
                            
                        </div>
                    </el-main>
                    <el-footer class="footer"> 浙江三生蔓迪药业有限公司 © {{new Date().getFullYear()}} 浙ICP备2021031497号-1 </el-footer>
                </el-container>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import vHead from './Head.vue'
import vLeftMenu from './LeftMenu.vue'
import vTabs from './Tabs.vue'
import {Base64} from 'js-base64'
import UserStorage from '../api/UserStorage';
import { getImFrameUrl, ENABLE_PERSISTENT_IM_FRAME, PERSISTENT_IFRAME_META_KEY, IM_FRAME_PROVIDE_KEY } from '../api/imFrame';
export default {
    components:{
        vHead,vLeftMenu,vTabs
    },
	data: function () {
		return {
			isHospital: false,
			hospitalUrl: process.env.VUE_APP_HOSPITAL_HOST,
			// IM 系统 iframe 由本布局常驻托管：首次进入 IM 菜单才创建，之后一直在，切菜单只切显隐
			imFrameUrl: getImFrameUrl(),
			imFrameMounted: false
		}
	},
    // 与路由使用同一开关：关闭常驻时，由 IM 页面组件自己渲染 iframe
    provide() {
        return {
            [IM_FRAME_PROVIDE_KEY]: ENABLE_PERSISTENT_IM_FRAME
        }
    },
    computed: {
        // 当前路由是否是使用常驻 iframe 的 IM 页面（由 RouteData 写入 meta.persistentIframe）
        showImFrame() {
            const meta = this.$route && this.$route.meta;
            return ENABLE_PERSISTENT_IM_FRAME && !!(meta && meta[PERSISTENT_IFRAME_META_KEY]);
        },
        //绑定唯一KEY，每次切换路由重新加载页面
        key() {
            let json = JSON.parse(Base64.decode(this.$route.query.data)); 
            return json.id; 
        },
        nickName(){
            return UserStorage.getUserInfo('nickName');
        },
        userName(){ 
            return UserStorage.getUserInfo('userName');
        },
        roleName(){ 
            return UserStorage.getUserInfo('roleName');
        }
    },
    watch: {
      nickName: {
        handler(newName, oldName) {
          this.setWatermarkFn();
        },
        immediate: true
      },
      // 首次进入 IM 菜单后一直保留 iframe（不随路由切换卸载）
      '$route': {
        handler() {
          if (this.showImFrame) this.imFrameMounted = true;
        },
        immediate: true
      }
    },
    created(){
        
    },
	methods: {
		// 是否展示康怡邦互联网医院
		onHospitalFn(e) {
			this.isHospital = e;
		},
        // 水印
        setWatermarkFn() {
          if(this.nickName) {
            this.$watermark.set(`${this.nickName}  ${this.userName}`)
          }else {
            this.$watermark.set('')
          }
        },
	}
}
</script>
<style scoped>
.hospital-view {
	height: 100vh;
}
.default{
    margin:0;
    padding:0;
    width:100%;
    height:100%;
}
.home-main{
    height:calc(100% - 47px);
    /* background: url(../assets/background.png) no-repeat; */
}
.content{
    width: 100%;
    height: 100%;
    position: relative;
    /* background: #FFFFFF; */
    /* border-radius: 5px; */
}
/* IM 常驻 iframe：铺满内容区；切到其它菜单时仅 display:none，元素不卸载、文档上下文不变 */
.im-persistent-view{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: block;
}
.footer{
    height:47px; 
    box-sizing: border-box;
  
    height: 47px; 
    line-height: 46px;
    background: #FFFFFF;  
    font-family: 'Abhaya Libre';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    color: #606266; 
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); 
    bottom: 0;
}
</style>
